@if (ready) {
  <div class="py-5">
    <form>
      <div class="row">
        <div class="form-group col-6">
          <label class="sr-only" for="firstName">First Name</label>
          <input type="email" class="form-control" id="firstName" placeholder="First Name"
            [formControl]="profileForm.get('firstName')">
          @if (formService.controlHasError( profileForm.get('firstName'), 'required')) {
            <div
              class="form-control-feedback">Last Name is required
            </div>
          }
        </div>
        <div class="form-group col-6">
          <label class="sr-only" for="lastName">Last Name</label>
          <input type="email" class="form-control" id="lastName" placeholder="Last Name"
            [formControl]="profileForm.get('lastName')" required>
          @if (formService.controlHasError( profileForm.get('lastName'), 'required')) {
            <div
              class="form-control-feedback">Last Name is required
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <label class="sr-only" for="profileEmail">Email</label>
        <input type="email" class="form-control" id="profileEmail" placeholder="Email" readonly
          [formControl]="profileForm.get('email')" required>
        @if (formService.controlHasError( profileForm.get('email'), 'required')) {
          <div
            class="form-control-feedback">Email is required
          </div>
        }
        @if (formService.controlHasError( profileForm.get('email'), 'email')) {
          <div
            class="form-control-feedback">Not valid email
          </div>
        }
      </div>
      <hr>
        <a class="btn btn-block btn-primary" (click)="resetPassword()">Reset Password</a>
        <hr>
          <div class="row">
            <div class="form-group col-6">
              <label class="col-form-label" for="birthday">Birth Date</label>
              <input class="form-control" type="date" value="" min="{{ minDate }}" max="{{ maxDate }}" id="birthday"
                [formControl]="profileForm.get('birthdate')" (change)="onDateChange($event)">
              @if (formService.controlHasError( profileForm.get('birthdate'), 'required')) {
                <div
                  class="form-control-feedback">Birthday is required
                </div>
              }
              @if (dateError) {
                <div class="form-control-feedback">{{ dateError }}
                </div>
              }
            </div>
            <div class="form-group col-6">
              <label class="col-form-label" for="profileGrade">Graduation Year</label>
              <select class="custom-select d-block" id="profileGrade" [formControl]="profileForm.get('graduationYear')">
                <option selected disabled>Graduation Year</option>
                @for (i of [0,1,2,3,4,5,6]; track i) {
                  <option value="{{currentYear + i}}">
                    {{currentYear + i}}
                  </option>
                }
              </select>
            </div>
          </div>
          <hr>
            <div class="row">
              <div class="col-6">
                <h5>Current Score</h5>
                <div class="form-group">
                  <label class="sr-only" for="currentEnglish">English</label>
                  <input type="number" class="form-control" id="currentEnglish" placeholder="English"
                    [formControl]="profileForm.get('currentScoreEnglish')">
                  @if (formService.controlHasError( profileForm.get('currentScoreEnglish'), 'required')) {
                    <div
                      class="form-control-feedback">English Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreEnglish'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreEnglish'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="sr-only" for="currentMath">Math</label>
                  <input type="number" class="form-control" id="currentMath" placeholder="Math"
                    [formControl]="profileForm.get('currentScoreMath')">
                  @if (formService.controlHasError( profileForm.get('currentScoreMath'), 'required')) {
                    <div
                      class="form-control-feedback">Math Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreMath'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreMath'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="sr-only" for="currentReading">Reading</label>
                  <input type="number" class="form-control" id="currentReading" placeholder="Reading"
                    [formControl]="profileForm.get('currentScoreReading')">
                  @if (formService.controlHasError( profileForm.get('currentScoreReading'), 'required')) {
                    <div
                      class="form-control-feedback">Reading Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreReading'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreReading'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="sr-only" for="currentScience">Science</label>
                  <input type="number" class="form-control" id="currentScience" placeholder="Science"
                    [formControl]="profileForm.get('currentScoreScience')">
                  @if (formService.controlHasError( profileForm.get('currentScoreScience'), 'required')) {
                    <div
                      class="form-control-feedback">Score Science is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreScience'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('currentScoreScience'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
              </div>
              <div class="col-6">
                <h5>Goal Score</h5>
                <div class="form-group">
                  <label class="sr-only" for="goalEnglish">English</label>
                  <input type="number" class="form-control" id="goalEnglish" placeholder="English"
                    [formControl]="profileForm.get('goalScoreEnglish')">
                  @if (formService.controlHasError( profileForm.get('goalScoreEnglish'), 'required')) {
                    <div
                      class="form-control-feedback">English Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreEnglish'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreEnglish'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="sr-only" for="goalMath">Math</label>
                  <input type="number" class="form-control" id="goalMath" placeholder="Math"
                    [formControl]="profileForm.get('goalScoreMath')">
                  @if (formService.controlHasError( profileForm.get('goalScoreMath'), 'required')) {
                    <div
                      class="form-control-feedback">Math Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreMath'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreMath'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="sr-only" for="goalReading">Reading</label>
                  <input type="number" class="form-control" id="goalReading" placeholder="Reading"
                    [formControl]="profileForm.get('goalScoreReading')">
                  @if (formService.controlHasError( profileForm.get('goalScoreReading'), 'required')) {
                    <div
                      class="form-control-feedback">Reading Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreReading'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreReading'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label class="sr-only" for="goalScience">Science</label>
                  <input type="number" class="form-control" id="goalScience" placeholder="Science"
                    [formControl]="profileForm.get('goalScoreScience')">
                  @if (formService.controlHasError( profileForm.get('goalScoreScience'), 'required')) {
                    <div
                      class="form-control-feedback">Science Score is required
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreScience'), 'max')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                  @if (formService.controlHasError( profileForm.get('goalScoreScience'), 'min')) {
                    <div
                      class="form-control-feedback">Score must be between 1-36
                    </div>
                  }
                </div>
              </div>
            </div>
            <a class="btn btn-block btn-primary" (click)="submitForm()">Update</a>
          </form>
        </div>
      } @else {
        <app-spinner></app-spinner>
      }

